import React from "react";
import { Box, Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Modal from "../Modal";
import { useTranslation } from "react-i18next";
import ButtonGroup from "../Buttons/ButtonGroup";
import ContentViewerNavigationButtons from "../ContentViewer/ContentViewerNavigationButtons";

const QuizCompletionModal = ({
  open,
  onClose,
  score,
  onNextActivityClick,
  onExitShortCourse,
  onReviewQuizClick,
  lastActivity,
  moduleCompleted
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      scrollable
      maxWidth="xs"
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {t("courseQuiz.quizSubmittedModalTitle")}
        </Typography>
      }
      dialogContent={
        <Box mb={6} mt={2}>
          <Typography variant="h5" sx={{ display: "inline" }}>
            {t("courseQuiz.youScoredText")}
          </Typography>
          <Typography
            variant="h5"
            color="primary"
            sx={{ display: "inline", fontWeight: "500" }}
          >
            {` ${Math.round(score)}%`}
          </Typography>
          <Typography sx={{ pt: 2.5 }}>
            {t("courseQuiz.reviewQuestionsText")}
          </Typography>
        </Box>
      }
      dialogActions={
        <ButtonGroup>
          <ContentViewerNavigationButtons
            handleNextActivity={onNextActivityClick}
            lastActivity={lastActivity || moduleCompleted}
            onExitShortCourse={onExitShortCourse}
            shortCourseCompleted={moduleCompleted}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => onReviewQuizClick()}
            data-qa="quiz-completion-review-quiz-btn"
          >
            {t("courseQuiz.reviewQuizBtn")}
          </Button>
        </ButtonGroup>
      }
      open={open}
      onClose={() => onClose()}
      data-qa="quiz-completion-modal"
    />
  );
};

export default QuizCompletionModal;

QuizCompletionModal.propTypes = {
  /**
   * True if the modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the modal is closed
   */
  onClose: PropTypes.func,
  /**
   * Called when the OK button is pressed
   */
  onSubmit: PropTypes.func
};
